export const searchTagOptions = (options, query) =>
  options.filter((option) => RegExp(query, 'i').test(option.text));
